import { useStore } from 'vuex'
import { judgeIsLocalDevEnv } from '@/utils'
import wx from 'weixin-js-sdk'

export function useCommonShare() {
  const $store = useStore()

  // 获取分享的链接信息
  function getShareUrlInfo(option?: { code?: string; urlSchmera?: string }) {
    const origin = judgeIsLocalDevEnv()
      ? 'https://after-sales-test.xair.cn'
      : window.location.origin
    const inviteNewUserUrl = `${origin}/activity/old-bring-new/new-user?code=${option?.code || ''}`
    // 默认都进入首页
    const commonShareUrl = `${origin}/activity/old-bring-new?code=${option?.code || ''}`
    const appMiddleWrapUrl = `${origin}/activity/old-bring-new/middle-wrap?url=${encodeURIComponent(
      option?.urlSchmera || ''
    )}`
    return {
      commonShareUrl,
      inviteNewUserUrl,
      appMiddleWrapUrl,
    }
  }

  function getShareBaseInfo() {
    const mainTitle = '助力春耕季，一起加入新农人队伍！'
    const secTitle = `${$store.state?.userInfo?.realName || ''}邀你共享春耕好礼`
    return {
      mainTitle,
      secTitle,
    }
  }

  function setMiniProgramShareInfo(type?: string) {
    console.log('$store.getters.isMiniProgram', $store.getters.isMiniProgram)
    if (!$store.getters.isMiniProgram) {
      return
    }
    const { secTitle } = getShareBaseInfo()
    const link =
      type === 'new'
        ? getShareUrlInfo({
            code: $store?.state?.OldBringsNew?.inviteCode || '',
          }).inviteNewUserUrl
        : getShareUrlInfo().commonShareUrl
    wx.miniProgram.postMessage({
      data: {
        title: secTitle,
        desc: secTitle,
        imgUrl:
          'https://office.static.xag.cn/upload-file/umtsj46ae6868ea9c/20260213/极飞2026 春耕 老带新长图文背景小程序分享6(1)-e0ab5dc1-b3cd-4ecd-900c-3ebf424bec64.jpg',
        link,
      },
    })
  }

  return {
    getShareBaseInfo,
    setMiniProgramShareInfo,
    getShareUrlInfo,
  }
}
